// extracted by mini-css-extract-plugin
export default {"header":"UG-z","blueBackground":"VG-z","hfImagesComponent":"WG-z","containedImage":"XG-z","headerContainer":"YG-z","headerButton":"ZG-z"};